import { CommentThreadBase, CommentThreadType } from '@/types';

export const cmThreadTypes = [
    CommentThreadType.ResidentialUnit,
    CommentThreadType.ChangeRequest,
    CommentThreadType.Order,
    CommentThreadType.ExternalAgreement,
    CommentThreadType.Project,
];

function isCmThreadType(threadType: CommentThreadType) {
    return cmThreadTypes.includes(threadType);
}

export function removeIrrelevantThreads<T extends CommentThreadBase>(data: T[] | null): T[] | null {
    if (!data) {
        return data;
    }

    return data.filter((x) => isCmThreadType(x.type));
}

// export function fixCommentsWorkaround(commentsOverview: ProjectCommentsOverview): ProjectCommentsOverview {
//     const threads = removeIrrelevantThreads(commentsOverview.threads);
//     return {
//         threads,
//         total: threads?.reduce((acc, curr) => acc + (curr.unreadMessages > 0 ? 1 : 0), 0) ?? 0,
//     };
// }
